module.exports = __webpack_public_path__ + "static/media/logo_creodias.7fb3ddfc.png";